import DOMPurify from "dompurify";
import {parseMergeTags} from "@/helpers";
import {useAppState} from "@/store";

export default function StepFooter() {
    const content = window.ein?.content?.general || {}
    const {state} = useAppState()

    const parsedContent = state.branch?.phone ? parseMergeTags(content.footer_text_branch, state) : content.footer_text;


    return (
        <div className={"text-center step-footer"} dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(parsedContent)}} />
    )
}
